export { default } from './MultiColumnChartWidget';
